export const conditionalOptions = [
  { label: "Yes", code: true },
  { label: "No", code: false },
];
export const availabilityOptions = [
  { label: "Full Time", code: "Full Time" },
  { label: "Part Time", code: "Part Time" },
];
export const contractOptions = [
  { label: "Permanent", code: "permanent_work" },
  { label: "Temporary", code: "temporary_work" },
];
export const conditionalOptionWithNotSelected = [
  { label: "Yes", code: true },
  { label: "No", code: false },
  { label: "Not Selected", code: "null" },
];
export const activeOptions = [
  { label: "Active", code: true },
  { label: "Deactivated", code: false },
  { label: "Not Selected", code: "null" },
];
export const isStudentOptions = [
  { label: "Student", code: true },
  { label: "Professional", code: false },
];
export const isProfessional = [
  { label: "Student", code: true },
  { label: "Qualified Healthcare Worker", code: false },
];
export const jobStatusOptions = [
  { label: "Draft Jobs", code: "un-published" },
  { label: "Published Jobs", code: "published" },
];
export const publishedOptions = [
  { label: "Draft", code: 27 },
  { label: "Pending", code: 28 },
  { label: "Published", code: 29 },
  { label: "Inactive", code: 30 },
  { label: "Archive", code: 31 },
];
export const jobAvailabilityOptions = [
  { label: "Full Time", code: "full_time" },
  { label: "Part Time", code: "part_time" },
];
export const isSponsored = [
  { label: "Yes", code: true },
  { label: "No", code: false },
];

export const eligible = [
  { label: "Green", code: "eligible" },
  { label: "Amber", code: "eligible_6_12" },
  { label: "Red", code: "eligible_12_plus" },
  { label: "Blue", code: "eligible_incomplete" },
];
export const fullPartTime = [
  { label: "Full Time", code: "Full Time" },
  { label: "Part Time", code: "Part Time" },
];

//For Education Type
export const disciplineEdu = [
  { label: "Medicine", code: 1 },
  { label: "Nursing", code: 2 },
  { label: "Midwifery", code: 2 },
  { label: "Dentistry", code: 4 },
  { label: "Social Care", code: 5 },
  { label: "Allied Health", code: 3 },
  { label: "Leadership / Management", code: 6 },
];

export const studentTypeEdu = [
  { label: "Undergraduate", code: 1 },
  { label: "Postgraduate", code: 2 },
  { label: "Foundation", code: 2 },
  { label: "Vocational", code: 4 },
  { label: "International", code: 5 },
];

export const enrollmentStatusEdu = [
  { label: "Enrolled", code: 1 },
  { label: "Applied", code: 2 },
  { label: "Offer Made", code: 2 },
  { label: "Offer Accepted", code: 4 },
  { label: "Waitlisted", code: 5 },
  { label: "Deferred", code: 6 },
  { label: "Withdrawn", code: 7 },
  { label: "Rejected", code: 8 },
  { label: "Enquiry", code: 9 },
];
export const gradePerformance = [
  { label: "High Performer", code: "eligible" },
  { label: "Very Good", code: "eligible_6_12" },
  { label: "On Track", code: "eligible_12_plus" },
  { label: "At Risk", code: "eligible_incomplete" },
  { label: "Incomplete / No Data", code: "eligible_incomplete" },
];
export const sponsorship = [
  { label: "All", code: "all" },
  { label: "Self-funded", code: "self_funded" },
  { label: "Government-sponsored", code: "government_sponsored" },
  { label: "Employer-sponsored", code: "employer_sponsored" },
  { label: "Scholarship / Grant", code: "null" },
];
